import { useTranslation } from 'next-i18next';
import { useDealerMapContext } from '../context/dealer-map-context';
import { useGtmTracking } from '../hooks/use-gtm-tracking';
import { DSIcon } from '@stihl-design-system/components';
import { cn } from '@phoenix/design-system/frontend/util/classNameUtils';

export const DealerPhoneNumberLabel = ({ phoneNumber }: { phoneNumber?: string }) => {
  const { t } = useTranslation(['shared']);
  const { trackPromotion } = useGtmTracking();
  const { selectedDealer } = useDealerMapContext();

  if (!phoneNumber || !selectedDealer) {
    return null;
  }

  return (
    <a
      href={`tel:${phoneNumber}`}
      className={cn(
        'flex items-center gap-2',
        'focus-visible:outline-offset-[2px] focus-visible:outline-[#252525] focus-visible:outline-[2px] focus-visible:outline'
      )}
      data-testid="dealer-details_phone-number"
      onClick={() => trackPromotion(selectedDealer, 'telto')}
      aria-label={t('shared_dealers_buttonPhone_aria', {
        dealer: selectedDealer.description,
        phoneNumber: phoneNumber,
      })}
    >
      <DSIcon name="phone" />
      <span className="stihl-text-body-default-reg">{phoneNumber}</span>
    </a>
  );
};
